import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import type {
  PayReportFilters,
  PayReportListResponse
} from '../types/payReport'

export const PAY_REPORT_QUERY_KEY = 'payment-reports'

export function buildPayReportQueryString(filters: PayReportFilters): string {
  const params = new URLSearchParams()
  params.set('startTime', filters.startTime)
  params.set('endTime', filters.endTime)
  filters.teamMemberIds.forEach((id, i) => {
    params.set(`teamMemberIds[${i}]`, id)
  })
  filters.contractTypes?.forEach((c, i) => {
    params.set(`contractTypes[${i}]`, c)
  })
  if (filters.page !== undefined && filters.pageSize !== undefined) {
    params.set('pagination[page]', String(Math.max(1, filters.page)))
    params.set('pagination[limit]', String(filters.pageSize))
  }
  if (filters.sortField !== undefined && filters.sortDir !== undefined) {
    params.set(`sort[${filters.sortField}]`, String(filters.sortDir))
  }
  return params.toString()
}

export const usePayReport = (
  filters: PayReportFilters | null,
  queryEnabled: boolean
) => {
  const qs = filters ? buildPayReportQueryString(filters) : ''
  return useQuery<PayReportListResponse>(
    [PAY_REPORT_QUERY_KEY, filters],
    () =>
      getJSON({
        url: `payment-reports/?${qs}`,
        isRota: true
      }),
    {
      enabled: queryEnabled && Boolean(filters),
      keepPreviousData: true,
      staleTime: 60 * 1000
    }
  )
}
